import { Box } from 'braid-design-system';

import * as styles from './ControlBox.css';

export const ControlBox = ({ children }: { children: React.ReactNode }) => (
  <Box
    borderRadius="standard"
    padding="xsmall"
    display="flex"
    alignItems="center"
    className={styles.controlBox}
  >
    {children}
  </Box>
);
